/* unplugin-vue-components disabled */import { render } from "./DashboardTable.vue?vue&type=template&id=b210b170&scoped=true&ts=true"
import script from "./DashboardTable.vue?vue&type=script&lang=ts"
export * from "./DashboardTable.vue?vue&type=script&lang=ts"

import "./DashboardTable.vue?vue&type=style&index=0&id=b210b170&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b210b170"]])

export default __exports__